import { Component, forwardRef, inject, OnDestroy, OnInit } from '@angular/core';
import { DocumentSelectComponent } from '../../shared/document-select/document-select.component';
import { HumanPipe } from '../../shared/pipes/human.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ProviderService } from '../provider.service';
import { IdentifierPipe } from '../../shared/pipes/identifier.pipe';
import { TitleCasePipe } from '@angular/common';
import { GoToCreateDirective } from '../../shared/directives/go-to-create.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-provider-select',
  templateUrl: './provider-select.component.html',
  styleUrls: [
    './provider-select.component.scss',
    '../../shared/document-select/document-select.component.scss'
  ],
  imports: [
    forwardRef(() => GoToCreateDirective),
    HumanPipe,
    IdentifierPipe,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TitleCasePipe,
  ],
  providers: [
    { 
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ProviderSelectComponent),
    }
  ]
})
export class ProviderSelectComponent extends DocumentSelectComponent implements ControlValueAccessor, OnInit, OnDestroy {
  private readonly providerService = inject(ProviderService);

  displayFn = (provider) => provider?.name;

  get service() {
    return this.providerService;
  }
}
